import type { EntityConfigDefinition } from '../../types/entityConfig'

const config: EntityConfigDefinition = {
  name: 'APPLICATION',
  idField: 'APPLICATION_ID',
  
  // Form processing configuration
  keepAuditFieldsOnUpdate: false,
  
  // Environment copy configuration
  preserveOnCopy: ['APPLICATION_ID'],
  
  // Environment comparison configuration
  comparisonConfig: {
    matchingFields: ['ORIGIN_APPLICATION_ID'],
    stringMatchFields: ['ORIGIN_APPLICATION_ID'],
    stringMatchThreshold: 0.50,
    displayFields: ['APPLICATION_ID', 'ORIGIN_APPLICATION_ID', 'PROCESS_FLAG', 'CREATED_DATE', 'CHANGED_DATE']
  },
  
  // Fields configuration
  fields: [
    "APPLICATION_ID",
    "ORIGIN_APPLICATION_ID",
    "PROCESS_FLAG",
    "CREATED_DATE",
    "CHANGED_DATE"
  ],
  
  // Form fields configuration
  formFields: [
    {
      name: "ORIGIN_APPLICATION_ID",
      type: "text",
      required: true,
      disabled: false
    },
    {
      name: "PROCESS_FLAG",
      type: "text",
      required: true,
      disabled: false
    },
    {
      name: "CREATED_DATE",
      type: "text",
      required: false,
      disabled: true
    },
    {
      name: "CHANGED_DATE",
      type: "text",
      required: false,
      disabled: true
    }
  ]
}

export default config
